
import React, { Component } from 'react'
import Title from '../GenericComponents/Title'
import Search from '../GenericComponents/Search'
import Loader from '../Loader/Loader'
import moment from 'moment'
import Paginations from '../GenericComponents/Pagination'
import Modals from '../GenericComponents/Modal'
import ProviderLevelModal from './ProviderLevelModal'
import {
  ProviderSettingsInlineToolbar,
  ProviderSettingsSearchInput,
  ProviderSettingsButtonSecondary,
  ProviderSettingsAddButton,
  ProviderSettingsToolbarActions,
} from './ProviderSettingsUi'
import { delete_ApiManager, put_ApiManager, post_ApiManager, view_ApiManager } from '../ApiManager/ApiManager'
import * as FaIcons from 'react-icons/fa'
import swal from 'sweetalert'
import '../../styles/tailwind.css'

class ViewLevels extends Component {
    constructor(props) {
      super(props);
      this.state = {
          loading:false,
          show:false,
          editModel:false,
          allLevels:[],
          totalItem:'',
          currentPage: 1,
          search:'',
          lastPage:'',
          perItem:'',
          perPage: 10,
          defaultValue:'',
          defaultCountryValue:'',
          editid:'',
          order:'ASC',
          searchKeyword: '',
          headers: [
              {name: '#' , field: "id", align: "text-center", key:1},
              {name: 'Levels' , field: "title", align: "text-center", key:2},
              {name: 'Category' , field: "country", align: "text-center", key:3},
              {name: 'Created At', field: 'created_at', align: "text-center", key:4},
              {name: '', field: '', key:5},
            ],
        }
    }

    componentDidMount() {
      this.getLevels();
    }
      // Get all categories from apis 
    async getLevels() {
        this.setState({loading: true});
        let currentPage = this.state.currentPage;
        let perPage = this.state.perPage;
        let url = 'levels';
        view_ApiManager(url, currentPage, perPage,(res) => {
        console.log('All levels',res);
        this.setState({
            allLevels: res.data.data['data'],
            loading: false,
            totalItem: res.data.data['total'],
            perPage: res.data.data['per_page'],
            lastPage: res.data.data['last_page'],
            perItem: res.data.data['data'].length,
        });
    },(err) => {
        console.log(err);
        this.setState({ loading: false });
    });
    }
      //CallBack pagination function
    handlePaginationCallback = (i, perPage) => {
      window.scrollTo(0, 0);
      if(this.state.search == ''){
          if(perPage && perPage != ''){
              this.setState({ perPage : perPage, currentPage:1}, () => {  this.getLevels();  }); 
          } else {this.setState({ currentPage : i}, () => { this.getLevels(); }); }
        } else{
          if(perPage && perPage != ''){
            this.setState({ perPage : perPage, currentPage:1}, () => {  this.handleSearchCallback(this.state.search);  }); 
        } else {this.setState({ currentPage : i}, () => { this.handleSearchCallback(this.state.search); }); }
        }
    }
    handleAddLevelSubmit = (name, country) => {
      if (!country || !name) {
        swal("", 'Please enter level and category', "error");
        return;
      }
      let url = 'levels';
      const data = { title: name, country: country };
      post_ApiManager(data, url, (res) => {
        console.log('Levels Added', res);
        if (res.data.error) swal(" ", res.data.error, "error");
        else {
          swal("Success!", res.data.message, "success");
          this.setState({ show: false });
          this.getLevels();
        }
      }, (err) => {
        console.log(err);
      });
    }

    handleEditLevelSubmit = (name, country) => {
      const Name = name || this.state.defaultValue;
      const Country = country || this.state.defaultCountryValue;
      let url = 'levels';
      const data = { title: Name, country: Country };
      put_ApiManager(data, this.state.editid, url, (res) => {
        console.log('Levels Edited', res);
        if (res.data.error) swal(" ", res.data.error, "error");
        else {
          swal("Success!", res.data.message, "success");
          this.setState({ editModel: false });
          this.getLevels();
        }
      }, (err) => {
        console.log(err);
      });
    }

    handleModelCallback = (toggle, type, name, country) => {
        this.setState({ show: !toggle });
        if (type === 'edit') {
            if (!country || !name) {
                swal("", 'Please enter level and category', "error");
                return false;
            }
            let url = 'levels';
            const data = { title: name, country: country };
            post_ApiManager(data, url, (res) => {
                console.log('Levels Added', res);
                if (res.data.error) swal(" ", res.data.error, "error");
                else {
                    swal("Success!", res.data.message, "success");
                    this.getLevels();
                }
            }, (err) => {
                console.log(err);
            });
        }
    }
      //CallBack function 
    handleCallback = () => {
      this.setState({show: true});
    }
      //CallBack function Model and get categories from api
    handleEditModelCallback = (toggle,type, name, country) => {
       this.setState({editModel:!toggle})
       if(type === 'edit'){
         var Name = name; 
         var Country = country;
         if(!name){
           Name = this.state.defaultValue;
          }
          if(!country){
              Country = this.state.defaultCountryValue;
          }
          let url = 'levels';
          const data = {title: Name, country: Country}
          put_ApiManager(data, this.state.editid, url,(res) => {
            console.log('Levels Edited',res);
            if(res.data.error) swal(" ", res.data.error, "error")
            else {swal("Success!", res.data.message, "success"); this.getLevels() } 
        },(err) => {
          console.log(err);
        });
      }
    }
      // Delete intake
    deleteLevel = (title, delete_id) => {
        swal({
            title: "Are you sure?",
            text: "You will not be able to recover ("+ title +")",icon: "warning", buttons: true, dangerMode: true,
          }).then((willDelete) => {
            if (willDelete){
            let url = 'levels';
            delete_ApiManager(delete_id, url,(res) => {
            console.log('Level Deleted',res);
            swal("Level ("+ title +")"+" deleted successfully", {icon: "success" });
            this.getLevels();
            this.setState({loading: false});
        },(err) => {
            console.log(err);
        }); }   
       });
    }
     // Table sorting
     sorting = (col) => {
      if(col){
          if(this.state.order === 'ASC'){
              const sorted = [...this.state.allLevels].sort((a,b)=>
              a[col] > b[col] ? 1 : -1 );
              this.setState({order:'DEC', allLevels: sorted});
              if (document.getElementById(col)) {
                document.getElementById(col).classList.remove('desc');
                document.getElementById(col).classList.add('asc');
              }
          } else if(this.state.order === 'DEC'){
              const sorted = [...this.state.allLevels].sort((a,b)=>
              a[col] < b[col] ? 1 : -1 );
              this.setState({order:'ASC', allLevels: sorted});
              if (document.getElementById(col)) {
                document.getElementById(col).classList.remove('asc');
                document.getElementById(col).classList.add('desc');
              }
          }
      }
     }
     //Search Api
     handleSearchCallback = (keyword) => {
        if(keyword){
            this.setState({search: keyword});
            let currentPage = this.state.currentPage;
            let perPage = this.state.perPage;
            let url = `search/levels/${keyword}`;
            view_ApiManager(url, currentPage, perPage,(res) => {
                console.log('search result',res);
                this.setState({
                    allLevels: res.data.data['data'],
                    totalItem: res.data.data['total'],
                    perPage: res.data.data['per_page'],
                    lastPage: res.data.data['last_page'],
                    perItem: res.data.data['data'].length,
                });
            },(err) => {
                console.log(err);
            });
        } else{
            this.setState({currentPage:1, search: ''});
            this.getLevels();
        }
    }

    handleEmbeddedSearchSubmit = (event) => {
      event?.preventDefault?.();
      this.handleSearchCallback(this.state.searchKeyword);
    }

    handleEmbeddedSearchClear = () => {
      this.setState({ searchKeyword: '' }, () => this.handleSearchCallback(''));
    }

  renderEmbeddedToolbar() {
    return (
      <ProviderSettingsInlineToolbar onSubmit={this.handleEmbeddedSearchSubmit}>
        <ProviderSettingsSearchInput
          value={this.state.searchKeyword}
          onChange={(event) =>
            this.setState({ searchKeyword: event.target.value })
          }
          placeholder="Search levels..."
        />
        <ProviderSettingsToolbarActions>
          <ProviderSettingsButtonSecondary type="submit" icon={FaIcons.FaSearch}>
            Search
          </ProviderSettingsButtonSecondary>
          <ProviderSettingsButtonSecondary onClick={this.handleEmbeddedSearchClear}>
            Clear
          </ProviderSettingsButtonSecondary>
          <ProviderSettingsAddButton onClick={this.handleCallback}>
            Add Level
          </ProviderSettingsAddButton>
        </ProviderSettingsToolbarActions>
      </ProviderSettingsInlineToolbar>
    );
  }

  renderEmbeddedTable() {
    let count = this.state.currentPage * this.state.perPage - this.state.perPage + 1;

    return (
      <>
        <div className="overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[640px] border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  {this.state.headers.map((head) => (
                    <th
                      key={head.key}
                      id={head.field || undefined}
                      onClick={() => head.field && this.sorting(head.field)}
                      className={`px-4 py-3.5 text-left text-xs font-bold uppercase tracking-wide text-gray-500 ${
                        head.field ? 'cursor-pointer select-none hover:text-gray-700' : ''
                      } ${head.name === '' ? 'w-28 text-right' : ''}`}
                    >
                      {head.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {this.state.loading ? (
                  [...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="border-t border-gray-100">
                      {[...Array(5)].map((__, cellIndex) => (
                        <td key={cellIndex} className="px-4 py-4">
                          <div className="h-4 animate-pulse rounded bg-gray-200" style={{ width: '55%' }} />
                        </td>
                      ))}
                    </tr>
                  ))
                ) : this.state.allLevels.length === 0 ? (
                  <tr>
                    <td colSpan={5}>
                      <div className="flex flex-col items-center justify-center px-6 py-14 text-center">
                        <FaIcons.FaGraduationCap size={40} className="text-gray-300" />
                        <h6 className="mt-3 mb-1 font-semibold text-gray-600">No levels found</h6>
                        <p className="mb-0 text-sm text-gray-400">
                          {this.state.search
                            ? 'Try a different search keyword.'
                            : 'Get started by adding your first course level.'}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  this.state.allLevels.map((value, index) => (
                    <tr
                      key={value.id || index}
                      className="border-t border-gray-100 transition hover:bg-blue-50/40"
                    >
                      <td className="px-4 py-3.5 text-sm font-medium text-gray-700">{count++}</td>
                      <td className="px-4 py-3.5 text-sm font-semibold text-gray-900">{value.title}</td>
                      <td className="px-4 py-3.5 text-sm text-gray-600">{value.country}</td>
                      <td className="px-4 py-3.5 text-sm text-gray-600">
                        {moment(value.created_at).format('DD MMM YYYY')}
                      </td>
                      <td className="px-4 py-3.5">
                        <div className="flex justify-end gap-2">
                          <button
                            type="button"
                            title="Edit"
                            onClick={() =>
                              this.setState(
                                {
                                  editid: value.id,
                                  defaultValue: value.title,
                                  defaultCountryValue: value.country,
                                },
                                () => this.setState({ editModel: true }),
                              )
                            }
                            className="inline-flex h-9 w-9 items-center justify-center rounded-lg border-0 bg-blue-50 text-blue-600 transition hover:bg-blue-600 hover:text-white"
                          >
                            <FaIcons.FaEdit size={13} />
                          </button>
                          <button
                            type="button"
                            title="Delete"
                            onClick={() => this.deleteLevel(value.title, value.id)}
                            className="inline-flex h-9 w-9 items-center justify-center rounded-lg border-0 bg-red-50 text-red-500 transition hover:bg-red-500 hover:text-white"
                          >
                            <FaIcons.FaTrashAlt size={13} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        {!this.state.loading && this.state.allLevels.length > 0 ? (
          <div className="mt-4">
            <Paginations
              currentPage={this.state.currentPage}
              total={this.state.totalItem}
              itemsPerPage={this.state.perPage}
              lastPage={this.state.lastPage}
              totalItems={this.state.totalItem}
              perItem={this.state.perItem}
              onPageChange={this.handlePaginationCallback}
            />
          </div>
        ) : null}
      </>
    );
  }

  render(){
    const { embedded } = this.props;
    let count = this.state.currentPage * this.state.perPage - this.state.perPage +1;

    if (embedded) {
      return (
        <>
          {this.renderEmbeddedToolbar()}
          {this.renderEmbeddedTable()}
          <ProviderLevelModal
            show={this.state.show}
            isEditing={false}
            levelLabel="Add New Level"
            onClose={() => this.setState({ show: false })}
            onSubmit={this.handleAddLevelSubmit}
          />
          <ProviderLevelModal
            show={this.state.editModel}
            isEditing
            levelLabel="Change Level Title"
            defaultTitle={this.state.defaultValue}
            defaultCategory={this.state.defaultCountryValue}
            onClose={() => this.setState({ editModel: false })}
            onSubmit={this.handleEditLevelSubmit}
          />
        </>
      );
    }

    return(
        <>
        <Title title="View Levels" 
         btnCol="col-lg-8 text-center pr-lg-2" 
         btn={true}
         back={true}
         btnText="Add New Level" 
         btnClass="float-right btn btn-success"
         parentCallback={this.handleCallback} 
         />

         {this.state.loading ? <Loader /> :
         <div className="row w-100 pl-3 pr-3 mb-5 mt-lg-2">
         <Search 
         onSearchChange= {this.handleSearchCallback} 
         />

          <table className="table table-bordered bg-white mb-1">
          {/* Headers */}
          <thead className="thead-dark">
          <tr>
          {this.state.headers.map(head => (
          <th id={head.field} className={head.align} onClick={() => this.sorting(head.field)} key={head.key}>
          {head.name}</th>
          ))}
          </tr>
          </thead>
          {/* End Headers */}
          <tbody>
          {this.state.allLevels.map((value, index) => (
          <tr key={index}>
          <td className='text-center'>{count++}</td>
          <td className='text-center name-text'>{value.title}</td>
          <td className='text-center'>{value.country}</td>
          <td className='text-center'>{moment(value.created_at).format('YYYY-MM-D')}</td>
          <td className='text-center w-20'>
          <div>
          <button onClick={() => 
          this.setState({ editid: value.id, defaultValue: value.title, 
          defaultCountryValue: value.country}, () => this.setState({editModel:true}))} 
          className='btn btn-primary m-1'>
          <FaIcons.FaEdit size={13} color={'#ffffffed'} />
          </button>
          <button onClick={() => this.deleteLevel(value.title, value.id)} className='btn btn-danger m-1'>
          <FaIcons.FaTrashAlt size={13} color={'#ffffffed'} />
          </button>
          </div>
          </td>
          </tr>
          ))}
          </tbody>
          </table>
          <Paginations
            currentPage= {this.state.currentPage}
            total= {this.state.totalItem} 
            itemsPerPage= {this.state.perPage}
            lastPage={this.state.lastPage}
            totalItems={this.state.totalItem}
            perItem={this.state.perItem}
            onPageChange= {this.handlePaginationCallback} 
          />
          </div>}
           {/* add new intake model */}
          <Modals
            show={this.state.show}
            title={'New Level'}
            data={'Add New Level'} 
            type={'category'}
            categoryDropdown={true}
            parentCallback = {this.handleModelCallback}
          />

           {/* edit intake model */}
          <Modals
            show={this.state.editModel}
            title={'Edit Level'}
            data={'Change Level Title'} 
            type={'category'}
            defaultValue={this.state.defaultValue}
            defaultTitleValue={this.state.defaultCountryValue}
            categoryDropdown={true}
            parentCallback = {this.handleEditModelCallback}
          />
          
        </>
    )
  }
}
export default ViewLevels